import { useMemo } from 'react';
import PortalIdParser from 'PortalIdParser';
import { VOIP } from '../../../types/CallSourceTypes';
import { useIsUngatedForRecordingsInFileManager } from '../../hooks/playerGateChecks';
import { maybeAddSearchParam } from '../../utils/maybeAddSearchParam';
import { jsx as _jsx } from "react/jsx-runtime";
export const withInternalAuthedRecordingUrl = Component => {
  return props => {
    const isVOIP = props.source === VOIP;
    const isUngatedForRecordingsInFileManager = useIsUngatedForRecordingsInFileManager();
    const crossOrigin = useMemo(() => {
      if (isUngatedForRecordingsInFileManager) {
        return isVOIP ? 'use-credentials' : undefined;
      }
      return isVOIP ? 'anonymous' : undefined;
    }, [isUngatedForRecordingsInFileManager, isVOIP]);
    const recordingUrl = useMemo(() => {
      if (isUngatedForRecordingsInFileManager && isVOIP) {
        return maybeAddSearchParam(props.recordingUrl, 'portalId', `${PortalIdParser.get()}`);
      }
      return props.recordingUrl;
    }, [isUngatedForRecordingsInFileManager, props.recordingUrl, isVOIP]);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      crossOrigin: crossOrigin,
      recordingUrl: recordingUrl
    }));
  };
};